import '../static/Logo.css';
import React__default from "react";
import Image from "next/image.js";
import clsx from "clsx";
import { b as bustMediaCache } from "./media.DVNzFvj8.mjs";
const logo = `_logo_8355b22`;
const sm = `_sm_93bfea4`;
const lg = `_lg_23bf7a8`;
const autoWidth = `_autoWidth_cedc302`;
const fixedWidth = `_fixedWidth_f1762d6`;
const styles = { logo, sm, lg, autoWidth, fixedWidth };
const LOGO_HEIGHT = 64;
const LOGO_SIZES = ["sm", "lg"];
const Logo = ({
  alternativeText,
  autoWidth: autoWidth2 = true,
  className,
  height,
  size = "sm",
  updatedAt,
  url,
  width,
  ...props
}) => {
  return /* @__PURE__ */ React__default.createElement(
    Image,
    {
      ...props,
      "data-ui-logo": true,
      className: clsx(
        styles.logo,
        styles[size],
        {
          [styles.autoWidth]: autoWidth2,
          [styles.fixedWidth]: !autoWidth2
        },
        className
      ),
      src: bustMediaCache(url, updatedAt),
      alt: alternativeText || "",
      width: width * LOGO_HEIGHT / height,
      height: LOGO_HEIGHT
    }
  );
};
export {
  LOGO_SIZES as L,
  Logo as a
};
//# sourceMappingURL=Logo.5_HKhQuM.mjs.map
